<template>
  <div>
    <van-swipe :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(image, index) in banner" :key="index" @click="onNavigate(image)">
        <image-pic width="100%" height="150" :src="image.url" />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
  export default {
    props: ['banner'],
    methods: {
      onNavigate(item) {
        if (item.type == 0){
          this.$router.push({
            path: '/productBannerList',
            query: { id: item.id,name: '轮播图'}
          })
        }
        if (item.type == 1 && item.link){
          window.location.href =  item.link
        }

      },
      bannerJump(item) {
        window.location.href = item.name
      },

    }
  }
</script>



// WEBPACK FOOTER //
// src/views/home/modules/Swiper.vue